import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { convertToCalendarDate } from '../../../utils/formatter';
import { commentLimitValidation, mileageValidation } from '../../../utils/validations';
import DatePicker from '../../shared/input/DatePicker';
import Input from '../../shared/input/Input';

const VisitForm = ({ onSubmit, visit, loading }) => {
  const methods = useForm({
    defaultValues: {
      ...visit,
      startDate: convertToCalendarDate(visit.startDate),
      endDate: convertToCalendarDate(visit.endDate),
    },
  });

  const startDate = methods.watch('startDate');
  const endDate = methods.watch('endDate');

  return (
    <FormProvider {...methods}>
      <form id="visit-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Пробіг автомобіля"
          type="input"
          name="mileage"
          autoFocus="true"
          disabled={loading}
          placeholder={'Введіть пробіг автомобіля'}
          validation={mileageValidation}
        />
        <DatePicker
          label="Дата початку робіт"
          name="startDate"
          max={endDate ? endDate : undefined}
          disabled={loading}
        />
        <DatePicker
          label="Дата кінця робіт"
          name="endDate"
          min={startDate ? startDate : undefined}
          disabled={loading}
        />
        <Input
          label="Коментар"
          multiline
          name="comment"
          disabled={loading}
          placeholder={'Введіть коментар до візиту'}
          validation={commentLimitValidation}
        />
      </form>
    </FormProvider>
  );
};

export default VisitForm;
